<template xmlns="http://www.w3.org/1999/html">
    <div class="animated fadeIn">
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-header">
                        <i class="fa fa-align-justify"></i> All Contracts
                    </div>
                    <div class="card-block">
                        <div class="col-md-12">
                            <div class="row form-group">
                                <div class="col-md-2 pl-0" style="max-width: fit-content;">
                                    <button class="btn btn-primary" @click="createContract()">New contract</button>
                                </div>
                                <div class="col-md-2 pr-0 pl-0" style="max-width: fit-content;">
                                    <button class="btn dg-btn--cancel" @click="fileUploadModal = true">Import single contract</button>
                                </div>
                                <!--<div class="col-md-2 pr-0 pl-0 ml-1" style="max-width: fit-content;">-->
                                    <!--<button class="btn dg-btn&#45;&#45;cancel" @click="importContractsModal = true">Import contracts</button>-->
                                <!--</div>-->
                                <div class="col-md-3 pr-0">
                                    <!--<label class="vcentered-text">Choose client</label>-->
                                    <select class="form-control" v-model="selected_template">
                                        <option v-for="template in templates_dropdown" :value="template.id">{{template.contract_name}}</option>
                                    </select>
                                </div>
                                <div class="col-md-2 pr-0">
                                    <button :disabled="!selected_template" class="btn dg-btn--ok" @click="createContractFromTemplate()">From template</button>
                                </div>
                                <!--<div class="col-md-6" style="display: inline-flex;">-->
                                    <!--<div class="col-md-4">-->
                                        <!--<label class="form-control-label" style="padding-top: 7px;">Search contract</label>-->
                                    <!--</div>-->
                                    <!--<div class="col-md-8 ml-0">-->
                                        <!--<input v-model="search_value" class="form-control" type="search"/>-->
                                    <!--</div>-->
                                <!--</div>-->
                            </div>
                        </div>
                        <!--<div class="col-md-12">-->
                            <div class="row">
                                <div class="col-md-3">
                                    <div class="col-md-12 pl-0">
                                        <label class="form-control-label" style="padding-top: 7px;">Document type</label>
                                    </div>
                                    <div class="col-md-12 ml-0 pl-0 pr-0">
                                        <select class="form-control" v-model="filter.document_type">
                                            <option :value="null">Document type</option>
                                            <option v-for="document in document_type" :value="document.value">{{document.name}}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-2 pl-0">
                                    <div class="col-md-12 pl-0">
                                        <label class="form-control-label" style="padding-top: 7px;">Search by contract Nr.</label>
                                    </div>
                                    <div class="col-md-12 ml-0 pl-0 pr-0">
                                        <!--<input v-model="filter.contract_number" class="form-control" type="search"/>-->
                                        <autocomplete :items="contractNumbers"
                                                      :item="contractNumber" v-model="contractNumber"
                                                      :min-len="0" :get-label="getContractLabel"
                                                      :component-item='contractNumberListTemplate'
                                                      @update-items="updateContractNumbers">
                                        </autocomplete>
                                    </div>
                                </div>
                                <div class="col-md-2 pl-0">
                                    <div class="col-md-12 pl-0">
                                        <label class="form-control-label" style="padding-top: 7px;">Search by client</label>
                                    </div>
                                    <div class="col-md-12 ml-0 pl-0 pr-0">
                                        <autocomplete :items="clientItems"
                                                      :item="clientItem" v-model="clientItem"
                                                      :min-len="0" :get-label="getClientLabel"
                                                      :component-item='clientListTemplate'
                                                      @update-items="updateClientItems">
                                        </autocomplete>
                                    </div>
                                </div>
                                <div class="col-md-3 pl-0">
                                    <div class="col-md-12 pl-0">
                                        <label class="form-control-label" style="padding-top: 7px;">Search contract</label>
                                    </div>
                                    <div class="col-md-12 ml-0 pl-0 pr-0">
                                        <input v-model="search_value" class="form-control" type="search"/>
                                    </div>
                                </div>
                                <div class="col-md-2 pl-0">
                                    <div class="col-md-12 pl-0">
                                        <label class="form-control-label" style="padding-top: 7px;">&nbsp;</label>
                                    </div>
                                    <div class="col-md-12 ml-0 pl-0 pr-0">
                                        <button class="btn dg-btn--cancel" @click="clearFilters()">Clear filters</button>
                                    </div>
                                </div>
                            </div>
                        <!--</div>-->
                        <table class="table table-bordered table-striped table-condensed mt-1">
                            <thead>
                            <tr>
                                <th>#</th>
                                <th>Name</th>
                                <th>Number</th>
                                <th>Status</th>
                                <th>Date</th>
                                <th>Document type</th>
                                <th>Contract type</th>
                                <th>Client title</th>
                                <th>Options</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-if="contracts.length" v-for="contract in contracts">
                                <td>{{contract.id}}</td>
                                <td>{{contract.contract_name}}</td>
                                <td>{{contract.contract_number}}</td>
                                <td>{{contract.contract_status}}</td>
                                <td>{{contract.contract_date}}</td>
                                <td>{{contract.document_type}}</td>
                                <td>{{contract.contract_type}}</td>
                                <td>{{contract.client_title}}</td>
                                <td>
                                    <i class="fa fa-edit fa-lg action" @click="editContract(contract)" rel="tooltip" title="Edit contract"></i>
                                    <i v-if="contract.contract_type != 'imported'" class="fa fa-copy fa-lg action" @click="copyContract(contract.id)" rel="tooltip" title="Copy contract"></i>

                                    <button v-if="contract.contract_type == 'system'" style="border: none; background-color: inherit;" class="fa fa-file-pdf-o fa-lg action"
                                      title="Print contract PDF" @click="download({newTab:true, url:'/api/print_contract', params:{contract_id:contract.id}},`${filenameFilter(contract.contract_name)}.pdf`)"></button>

                                    <button v-if="contract.contract_type == 'system'" style="border: none; background-color: inherit;" class="fa fa-file-word-o fa-lg action"
                                      title="Print contract Docx" @click="download({url:'/api/print_contract_to_msword', params:{contract_id:contract.id}},`${filenameFilter(contract.contract_name)}.docx`)"></button>

                                    <button v-if="contract.contract_type == 'imported'" style="border: none; background-color: inherit;" class="fa fa-file-pdf-o fa-lg action"
                                      title="Download contract" @click="download({url:'/api/print_contract_imported', params:{contract_id:contract.id}})"></button>

                                    <i class="fa fa-trash fa-lg action" @click="deleteContract(contract)" rel="tooltip" title="Delete contract"></i>
                               </td>
                            </tr>
                            </tbody>
                        </table>
                        <div id="page">
                            <template class="temp">
                                <v-page :setting="pageSet" @page-change="pageChange"></v-page>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <modal :show="true" :backdrop="false" title="Import contract" v-model="fileUploadModal" effect="fade/zoom">
            <div slot="modal-header" class="modal-header">
                <h4 class="modal-title">Add contract data</h4>
            </div>
            <div class="form-group row">
                <label class="col-md-3 form-control-label">Contract name</label>
                <div class="col-md-9">
                    <input type="text" class="form-control" placeholder="Name" v-model="fileUploadInfo.contract_name">
                </div>
            </div>
            <div class="form-group row">
                <label class="col-md-3 form-control-label">Contract number</label>
                <div class="col-md-9">
                    <input type="text" class="form-control" placeholder="Number" v-model="fileUploadInfo.contract_number">
                </div>
            </div>
            <div class="form-group row">
                <label class="col-md-3 form-control-label">Contract date</label>
                <div class="col-md-9">
                    <datepicker placeholder="yyyy-mm-dd" input-class="upload-contract-date-picker" v-model="singleContractDate" format="yyyy-MM-dd"></datepicker>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-md-3 form-control-label">Document type</label>
                <div class="col-md-9">
                    <select class="form-control" v-model="fileUploadInfo.document_type">
                        <option v-for="document in document_type" :value="document.value">{{document.name}}</option>
                    </select>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-md-3 form-control-label">Document status</label>
                <div class="col-md-9">
                    <select class="form-control" v-model="fileUploadInfo.contract_status">
                        <option v-for="status in statuses" :value="status.value">{{status.name}}</option>
                    </select>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-md-3 form-control-label">Client</label>
                <div class="col-md-9 z-1">
                    <autocomplete :items="uploadContractClientItems"
                                  :item="uploadContractClientItem" v-model="uploadContractClientItem"
                                  :min-len="0" :get-label="getClientLabel"
                                  :component-item='clientListTemplate'
                                  @update-items="updateUploadContractClientItems">
                    </autocomplete>
                </div>
            </div>
            <div class="form-group row justify-content-end pr-1">
                <div class="col-md-6 pl-0" style="max-width: 130px;">
                    <file-upload
                      class="btn btn-primary"
                      :post-action= uploadContractUrl
                      :multiple="true"
                      :data="fileUploadInfo"
                      :timeout="500"
                      v-model="singleContractFiles"
                      ref="uploadContracts">
                        <i class="fa fa-plus"></i>
                        Select files
                    </file-upload>
                </div>
                <div class="col-md-6 pl-0 pr-0" style="max-width: 130px;">
                    <button type="button" class="btn btn-success" v-if="!$refs.uploadContracts || !$refs.uploadContracts.active" @click.prevent="$refs.uploadContracts.active = true">
                        <i class="fa fa-arrow-up" aria-hidden="true"></i>
                        Start Upload
                    </button>
                    <button type="button" class="btn btn-danger"  v-else @click.prevent="$refs.uploadContracts.active = false">
                        <i class="fa fa-stop" aria-hidden="true"></i>
                        Stop Upload
                    </button>
                </div>
            </div>
            <div class="form-group row justify-content-center">
                <div class="uploadContracts">
                    <table class="table table-bordered table-striped table-condensed files-table" v-if="singleContractFiles.length > 0">
                        <thead>
                        <tr>
                            <th>File name</th>
                            <th>File size</th>
                            <th>Upload status</th>
                            <th>Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(file, index) in singleContractFiles" :key="file.id">
                            <td><span>{{file.name | truncate(25)}}</span></td>
                            <td><span>{{file.size}}</span></td>
                            <td>
                                <span v-if="file.error">{{file.error}}</span>
                                <span v-else-if="file.success">success</span>
                                <span v-else-if="file.active">active</span>
                                <span v-else-if="file.active">active</span>
                                <span v-else></span>
                            </td>
                            <td>
                                <div class="btn-group" v-if="!file.success">
                                    <button class="btn btn-secondary btn-sm dropdown-toggle" type="button">
                                        Action
                                    </button>
                                    <div class="dropdown-menu">
                                        <!--<a :class="{'dropdown-item': true, disabled: !file.active}" href="#" @click.prevent="file.active ? $refs.uploadContracts.update(file, {error: 'cancel'}) : false">Cancel</a>-->

                                        <a class="dropdown-item" href="#" v-if="file.active" @click.prevent="$refs.uploadContracts.update(file, {active: false})">Abort</a>
                                        <a class="dropdown-item" href="#" v-else-if="file.error && file.error !== 'compressing' && $refs.uploadContracts.features.html5" @click.prevent="$refs.uploadContracts.update(file, {active: true, error: '', progress: '0.00'})">Retry upload</a>
                                        <!--<a :class="{'dropdown-item': true, disabled: file.success || file.error === 'compressing'}" href="#" v-else @click.prevent="file.success || file.error === 'compressing' ? false : $refs.uploadContracts.update(file, {active: true})">Upload</a>-->

                                        <!--<div class="dropdown-divider"></div>-->
                                        <a class="dropdown-item" v-if="!file.success" href="#" @click.prevent="$refs.uploadContracts.remove(file)">Remove</a>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div slot="modal-footer" class="modal-footer">
                <!--<button type="button" class="btn btn-primary" @click="uploadContract()">Save changes</button>-->
                <button type="button" class="btn btn-secondary" @click="closeUploadContractModal()">Close</button>
            </div>
        </modal>
        <!--<modal  :backdrop="false" title="Import contracts" v-model="importContractsModal" effect="fade/zoom">-->
            <!--<div slot="modal-header" class="modal-header">-->
                <!--<h4 class="modal-title">Add contracts</h4>-->
            <!--</div>-->
            <!--<div class="form-group row justify-content-end pr-1">-->
                <!--<div class="col-md-6 pl-0" style="max-width: 130px;">-->
                    <!--<file-upload-->
                      <!--class="btn btn-primary"-->
                      <!--:post-action= url-->
                      <!--:multiple="true"-->
                      <!--v-model="files"-->
                      <!--ref="upload">-->
                        <!--<i class="fa fa-plus"></i>-->
                        <!--Select files-->
                    <!--</file-upload>-->
                <!--</div>-->
                <!--<div class="col-md-6 pl-0 pr-0" style="max-width: 130px;">-->
                    <!--<button type="button" class="btn btn-success" v-if="!$refs.upload || !$refs.upload.active" @click.prevent="$refs.upload.active = true">-->
                        <!--<i class="fa fa-arrow-up" aria-hidden="true"></i>-->
                        <!--Start Upload-->
                    <!--</button>-->
                    <!--<button type="button" class="btn btn-danger"  v-else @click.prevent="$refs.upload.active = false">-->
                        <!--<i class="fa fa-stop" aria-hidden="true"></i>-->
                        <!--Stop Upload-->
                    <!--</button>-->
                <!--</div>-->
            <!--</div>-->
            <!--<div class="form-group row justify-content-center">-->
                <!--<div class="upload">-->
                    <!--<table class="table table-bordered table-striped table-condensed files-table" v-if="files.length > 0">-->
                        <!--<thead>-->
                        <!--<tr>-->
                            <!--<th>File name</th>-->
                            <!--<th>File size</th>-->
                            <!--<th>Upload status</th>-->
                            <!--<th>Actions</th>-->
                        <!--</tr>-->
                        <!--</thead>-->
                        <!--<tbody>-->
                        <!--<tr v-for="(file, index) in files" :key="file.id">-->
                            <!--<td><span>{{file.name}}</span></td>-->
                            <!--<td><span>{{file.size}}</span></td>-->
                            <!--<td>-->
                                <!--<span v-if="file.error">{{file.error}}</span>-->
                                <!--<span v-else-if="file.success">success</span>-->
                                <!--<span v-else-if="file.active">active</span>-->
                                <!--<span v-else-if="file.active">active</span>-->
                                <!--<span v-else></span>-->
                            <!--</td>-->
                            <!--<td>-->
                                <!--<div class="btn-group" v-if="!file.success">-->
                                    <!--<button class="btn btn-secondary btn-sm dropdown-toggle" type="button">-->
                                        <!--Action-->
                                    <!--</button>-->
                                    <!--<div class="dropdown-menu">-->
                                        <!--&lt;!&ndash;<a :class="{'dropdown-item': true, disabled: !file.active}" href="#" @click.prevent="file.active ? $refs.upload.update(file, {error: 'cancel'}) : false">Cancel</a>&ndash;&gt;-->

                                        <!--<a class="dropdown-item" href="#" v-if="file.active" @click.prevent="$refs.upload.update(file, {active: false})">Abort</a>-->
                                        <!--<a class="dropdown-item" href="#" v-else-if="file.error && file.error !== 'compressing' && $refs.upload.features.html5" @click.prevent="$refs.upload.update(file, {active: true, error: '', progress: '0.00'})">Retry upload</a>-->
                                        <!--&lt;!&ndash;<a :class="{'dropdown-item': true, disabled: file.success || file.error === 'compressing'}" href="#" v-else @click.prevent="file.success || file.error === 'compressing' ? false : $refs.upload.update(file, {active: true})">Upload</a>&ndash;&gt;-->

                                        <!--&lt;!&ndash;<div class="dropdown-divider"></div>&ndash;&gt;-->
                                        <!--<a class="dropdown-item" href="#" @click.prevent="$refs.upload.remove(file)">Remove</a>-->
                                    <!--</div>-->
                                <!--</div>-->
                            <!--</td>-->
                        <!--</tr>-->
                        <!--</tbody>-->
                    <!--</table>-->
                <!--</div>-->
            <!--</div>-->
            <!--<div slot="modal-footer" class="modal-footer">-->
                <!--&lt;!&ndash;<button type="button" class="btn btn-primary" @click="uploadContract()">Save changes</button>&ndash;&gt;-->
                <!--<button type="button" class="btn btn-secondary" @click="closeImportContractsModal()">Close</button>-->
            <!--</div>-->
        <!--</modal>-->
    </div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex';
import modal from 'vue-strap/src/Modal';
import FileUpload from 'vue-upload-component';
import VueNotifications from 'vue-notifications';
import Autocomplete from 'v-autocomplete';
import Datepicker from 'vuejs-datepicker';
import moment from 'moment';
import vPage from '../libraries/vPage/vPage.vue';
import ClientsAutocompleteDropdownItem from './ClientsAutocompleteDropdownItem.vue';
import ContractNumbersDropdownItem from './ContractNumbersDropdownItem.vue';
import { download, filenameFilter } from '@/_axios';

export default {
  name: 'Contracts',
  components: {
    modal,
    FileUpload,
    vPage,
    Autocomplete,
    Datepicker
  },
  data() {
    return {
      download: download,
      filenameFilter: filenameFilter,
      clientListTemplate: ClientsAutocompleteDropdownItem,
      contractNumberListTemplate: ContractNumbersDropdownItem,
      clientItem: '',
      clientItems: [],
      uploadContractClientItem: '',
      uploadContractClientItems: [],
      contractNumber: '',
      contractNumbers: [],
      pageSet: {
        totalRow: '',
        language: 'en',
        pageSizeMenu: [10, 20, 50, 100],
        pageNumber: 1,
        pageSize: 10,
        currentPage: ''
      },
      search_value: '',
      timeout_id: '',
      files: [],
      url: '/api/upload_contracts',
      uploadContractUrl: '/api/upload_single_contract',
      confirmation_options: {
        okText: 'Delete',
        cancelText: 'Cancel',
        verification: 'delete'
      },
      selected_template: '',
      document_type: [
        {
          name: 'Main contract',
          value: 'main_contract'
        },
        {
          name: 'Agreement protocol',
          value: 'agreement_protocol'
        },
        {
          name: 'Invoice',
          value: 'invoice'
        },
        {
          name: 'Document form',
          value: 'document_form'
        },
        {
          name: 'Acceptance act with invoice',
          value: 'acceptance_act_and_invoice'
        },
        {
          name: 'Appendix',
          value: 'appendix',
        },
        {
          name: 'Proposal for client',
          value: 'proposal_for_client'
        },
        {
          name: 'Acceptance act',
          value: 'acceptance_act'
        }
      ],
      statuses: [
        {
          name: 'Draft',
          value: 'draft'
        },
        {
          name: 'Sent to client',
          value: 'sent_to_client'
        },
        {
          name: 'Review',
          value: 'in_review'
        },
        {
          name: 'Done',
          value: 'done'
        }
      ],
      filter: {
        document_type: '',
        contract_number: '',
        client_name: ''
      },
      fileUploadModal: false,
      fileUploadInfo: {
        contract_name: '',
        contract_status: '',
        contract_type: '',
        contract_number: '',
        contract_date: moment().format('YYYY-MM-DD'),
        client_id: '',
        contract_content: '<p><strong>PIELIKUMĀ</strong></p>',
        document_type: '',
        first_file: ''
      },
      singleContractDate: moment().format('YYYY-MM-DD'),
      singleContractFiles: [],
      importContractsModal: false
    };
  },
  watch: {
    files: function (val) {
      for (const i in this.files) {
        this.files[i].name = this.files[i].name.replace(/[^\x00-\x7F]/g, '');
      }
    },
    //            fileUploadInfo: {
    //                handler: function (val) {
    //                    let urlParams = encodeURIComponent(JSON.stringify(this.fileUploadInfo));
    //                    this.uploadContractUrl = '/api/upload_single_contract' + '&data=' + urlParams;
    //                    console.log('ūrla', this.uploadContractUrl);
    //                },
    //                deep: true
    //            },
    singleContractDate: function (val) {
      if (val) {
        this.fileUploadInfo.contract_date = moment(this.singleContractDate).format('YYYY-MM-DD');
      } else {
        this.fileUploadInfo.contract_date = '';
      }
    },
    'singleContractFiles.length': {
      handler: function (val) {
        for (const i in this.singleContractFiles) {
          if (i == 0) {
            this.singleContractFiles[i].data.first_file = 1;
          } else {
            this.singleContractFiles[i].data.first_file = 0;
          }
          if (this.singleContractFiles[i].name) {
            this.singleContractFiles[i].name = this.singleContractFiles[i].name.replace(/[^\x00-\x7F]/g, '');
          }
        }
      },
      deep: true
    },
    singleContractFiles: {
      handler: function () {
        for (const i in this.singleContractFiles) {
          if (this.singleContractFiles[0].error) {
            this.$refs.uploadContracts.active = false;
          }
        }
      },
      deep: true
    },
    uploadContractClientItem: function (val) {
      if (val) {
        this.fileUploadInfo.client_id = val.id;
      }
    },
    contracts: function (val) {
      this.pageSet.totalRow = this.contracts_count;
    },
    search_value: function (val) {
      this.pageSet.currentPage = 0;
      const vm = this;
      if (vm.timeout_id) {
        clearTimeout(vm.timeout_id);
      }
      vm.timeout_id = setTimeout(() => {
        vm.pageSet.currentPage = 1;
        vm.GET_CONTRACTS_LIST({
          search_value: vm.search_value,
          pageNumber: 1,
          pageSize: vm.pageSet.pageSize,
          document_type: vm.filter.document_type,
          client_name: vm.filter.client_name,
          contract_number: vm.filter.contract_number
        });
      }, 1000);
    },
    deleted_contract: function (val) {
      if (this.deleted_contract.status == 'success') {
        this.showSuccessMsg({ title: 'Contract delete status', message: `Contract ${this.deleted_contract.data.contract_name} deleted!` });
      }
      if (this.deleted_contract.status == 'error') {
        this.showErrorMsg({ title: 'Contract delete status', message: this.deleted_contract.message });
      }
    },
    copied_contract: function (val) {
      if (this.copied_contract.status == 'success') {
        this.showSuccessMsg({ title: 'Contract copy status', message: `Contract ${this.copied_contract.data.contract_name} copied!` });
      }
      if (this.copied_contract.status == 'error') {
        this.showErrorMsg({ title: 'Contract copy status', message: this.copied_contract.message });
      }
    },
    clients: function () {
      this.clientItems = this.clients;
      this.uploadContractClientItems = this.clients;
    },
    clientItem: function (val) {
      if (val) {
        this.filter.client_name = val.title;
      } else {
        this.filter.client_name = null;
      }
    },
    contractNumber: function (val) {
      if (val) {
        this.filter.contract_number = val.contract_number;
      } else {
        this.filter.contract_number = null;
      }
    },
    fileUploadModal: function () {
      // if (this.fileUploadModal == true) {
      //   $('.projects-div').css('z-index', '0');
      // } else {
      //   $('.projects-div').css('z-index', '1');
      // }
    },
    importContractsModal: function () {
      // if (this.importContractsModal == true) {
      //   $('.projects-div').css('z-index', '0');
      // } else {
      //   $('.projects-div').css('z-index', '1');
      // }
    },
  },
  computed: {
    ...mapGetters('Clients', [
      'contracts',
      'deleted_contract',
      'copied_contract',
      'contracts_count',
      'clients'
    ]),
    ...mapGetters('Templates', [
      'templates_dropdown'
    ])
  },
  methods: {
    ...mapActions('Clients', [
      'GET_CONTRACTS_LIST',
      'DELETE_CONTRACT',
      'COPY_CONTRACT',
      'GET_CLIENTS_LIST',
      'SEARCH_CLIENTS',
      'SEARCH_CONTRACTS'
    ]),
    ...mapActions('Templates', [
      'TEMPLATES_DROPDOWN'
    ]),
    openFileUploadModal() {
      this.fileUploadModal = true;
    },
    closeUploadContractModal() {
      let errors = 0;
      let notUploaded = 0;
      for (const i in this.singleContractFiles) {
        if (this.singleContractFiles[i].progress == '0.00') {
          notUploaded++;
        }
        if (this.singleContractFiles[i].error) {
          errors++;
        }
      }
      if (errors > 0 || notUploaded > 0) {
        const vm = this;
        this.$dialog.confirm(
          '<p><b>Are you sure to close window?</b></p>'
                                    + `<p>Errors ocurred: ${errors}</p>`
                                    + `<p>Forgot to upload: ${notUploaded}</p>`,
          { okText: 'Close', cancelText: 'Cancel', verification: 'close', html: true },
        )
          .then(() => {
            vm.clearFileUploadInfoData();
          })
          .catch(() => {
          });
      } else {
        this.clearFileUploadInfoData();
      }
    },
    closeImportContractsModal() {
      this.files = [];
      this.importContractsModal = false;
    },
    clearFileUploadInfoData() {
      this.fileUploadInfo = {
        contract_name: '',
        contract_status: '',
        contract_type: '',
        contract_number: '',
        contract_date: moment().format('YYYY-MM-DD'),
        client_id: '',
        contract_content: '<p><strong>PIELIKUMĀ</strong></p>',
        document_type: '',
      };
      this.singleContractDate = '';
      this.singleContractFiles = [];
      this.uploadContractClientItem = '';
      this.fileUploadModal = false;
    },
    clearFilters() {
      this.filter = {
        document_type: '',
        contract_number: '',
        client_name: ''
      };
      this.search_value = '';
      this.clientItem = '';
      this.contractNumber = '';
    },
    pageChange(pInfo) {
      this.pageSet.pageNumber = pInfo.pageNumber;
      this.pageSet.pageSize = pInfo.pageSize;
      this.GET_CONTRACTS_LIST({
        search_value: this.search_value,
        pageNumber: this.pageSet.pageNumber,
        pageSize: this.pageSet.pageSize,
        document_type: this.filter.document_type,
        client_name: this.filter.client_name,
        contract_number: this.filter.contract_number
      });
      //                console.log(pInfo);//{pageNumber: 1, pageSize: 10}
    },
    editContract(contract) {
      this.$router.push({ name: 'EditContract', params: { id: contract.id } });
    },
    deleteContract(contract) {
      const vm = this;
      this.$dialog.confirm(`Delete contract - ${contract.contract_name}?`, this.confirmation_options)
        .then(() => {
          vm.DELETE_CONTRACT(contract.id);
        })
        .catch(() => {

        });
    },
    copyContract(id) {
      this.COPY_CONTRACT(id);
    },
    createContract() {
      this.$router.push({ name: 'NewContract' });
    },
    createContractFromTemplate() {
      this.$router.push({ name: 'NewContract', params: { id: this.selected_template } });
    },
    getClientLabel(item) {
      if (item) {
        return item.title;
      }
      return '';
    },
    getContractLabel(item) {
      if (item) {
        return item.contract_number;
      }
      return '';
    },
    updateClientItems(text) {
      this.SEARCH_CLIENTS(text).then((response) => {
        this.clientItems = response.data.data;
      }, (err) => {

      });
    },
    updateUploadContractClientItems(text) {
      this.SEARCH_CLIENTS(text).then((response) => {
        this.uploadContractClientItems = response.data.data;
      }, (err) => {

      });
    },
    updateContractNumbers(text) {
      this.SEARCH_CONTRACTS(text).then((response) => {
        this.contractNumbers = response.data.data;
      }, (err) => {

      });
    }
  },
  notifications: {
    showSuccessMsg: {
      type: VueNotifications.types.success
    },
    showInfoMsg: {
      type: VueNotifications.types.info
    },
    showWarnMsg: {
      type: VueNotifications.types.warn
    },
    showErrorMsg: {
      type: VueNotifications.types.error
    }
  },
  mounted() {
    this.TEMPLATES_DROPDOWN();
    this.GET_CLIENTS_LIST();
    this.updateContractNumbers('');
    this.GET_CONTRACTS_LIST(
      { search_value: this.search_value,
        pageNumber: this.pageSet.pageNumber,
        pageSize: this.pageSet.pageSize,
        document_type: this.filter.document_type,
        client_name: this.filter.client_search_value,
        contract_number: this.filter.contract_number
      }
    );
    // this.$watch(
    //     (val) => {
    //         if(this.$refs.upload.active == false){
    //             this.GET_CONTRACTS_LIST({
    //                 search_value: this.search_value,
    //                 pageNumber: this.pageSet.pageNumber,
    //                 pageSize: this.pageSet.pageSize,
    //                 document_type: this.filter.document_type,
    //                 client_name: this.filter.client_name,
    //                 contract_number: this.filter.contract_number
    //             });
    //         }
    //     }
    // )
    this.$watch(
      (val) => {
        if (this.$refs.uploadContracts.active == false) {
          this.GET_CONTRACTS_LIST({
            search_value: this.search_value,
            pageNumber: this.pageSet.pageNumber,
            pageSize: this.pageSet.pageSize,
            document_type: this.filter.document_type,
            client_name: this.filter.client_name,
            contract_number: this.filter.contract_number
          });
        }
      }
    );
  }
};
</script>

<style lang="scss" scope>
    .action {
        margin-left: 5px;

        &:hover {
            cursor: pointer;
            color: #ee0044;
        }
    }

    .dg-btn--ok {
        color: #fff;
        background-color: #20a8d8;
        border-color: #20a8d8;
        border-radius: var(--border-radius);
    }

    .dg-btn--ok:hover {
        box-shadow: inset 0 0 0 20rem var(--darken-1);
        background-color: #1985ac;
        border-color: #187fa3;

    }

    .dg-btn--ok:active {
        box-shadow: inset 0 0 0 20rem var(--darken-2),
        inset 0 3px 4px 0 var(--darken-3),
        0 0 1px var(--darken-2);
    }

    .dg-btn--ok:disabled,
    .dg-btn--ok.is-disabled {
        opacity: .5;
    }

    .dg-btn--cancel {
        color: #263238;
        background-color: #fff;
        border-color: #b0bec5;
        border-radius: var(--border-radius);
    }

    .dg-btn--cancel:hover {
        box-shadow: inset 0 0 0 20rem var(--darken-1);
        background-color: #e6e5e5;
        border-color: #8da1ab;

    }

    .dg-btn--cancel:active {
        box-shadow: inset 0 0 0 20rem var(--darken-2),
        inset 0 3px 4px 0 var(--darken-3),
        0 0 1px var(--darken-2);
    }

    .dg-btn--cancel:disabled,
    .dg-btn--cancel.is-disabled {
        opacity: .5;
    }
    .v-autocomplete-input {
        display: block;
        width: 100%;
        padding: 0.5rem 0.75rem;
        font-size: 0.875rem;
        line-height: 1.25;
        color: #607d8b;
        background-color: #fff;
        background-image: none;
        background-clip: padding-box;
        border: 1px solid rgba(0, 0, 0, 0.15);
        border-radius: 0;
    }
    .v-autocomplete-list {
        width: 100%;
        position: absolute;
        text-align: left;
        border: 1px solid rgba(0, 0, 0, 0.15);
        border-radius: 0;
        /*border-top: none;*/
        max-height: 200px;
        overflow-y: auto;
        /*border-bottom: 1px solid #157977;*/
    }
    .v-autocomplete-list-item {
        cursor: pointer;
        padding: 5px;
        border: 1px solid rgba(0, 0, 0, 0.15);
    }
    .v-autocomplete-list-item:hover {
        background-color: #e6e6e6;
    }
    .files-table {
        max-width: 600px;
    }
    .files-table td, th {
        padding: 5px;
    }
    .files-table th {
        font-weight: bold;
        text-align: center;
    }
    .vdp-datepicker__calendar {
        width: inherit;
    }
    .z-1 {
        z-index: 1;
    }
    .btn-group .dropdown-menu {
        display: block;
        visibility: hidden;
        transition: all .2s;
        min-width: inherit;
    }
    .btn-group:hover > .dropdown-menu {
        visibility: visible;
    }
    label.dropdown-item {
        margin-bottom: 0;
        padding: 5px;
    }
    .btn-group .dropdown-toggle {
        margin-right: .6rem
    }
</style>
<style>
    .upload-contract-date-picker {
        width: 100%;
        border: 1px solid rgba(0, 0, 0, 0.15);
        color: #607d8b;
        padding: 0.5rem 0.75rem;
    }
</style>
